<template>
  <FondationApp />
  <VersionUpdateBanner />
</template>

<script setup lang="ts">
import { App as FondationApp } from '@fondationcss/ui';
import VersionUpdateBanner from '@/components/version-update-banner.vue';
</script>
